import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid2 } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { BOX_SHADOW, Dashboard_URL } from '../../shared/constants';
import { useEventDetail, useEventsApartmentList, usePriceEventDetail } from '../../assets/api/useGetApi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TextSkeleton } from '../../shared/utils/SkeletonCom';
import { useMutation } from '@tanstack/react-query';
import api from '../../assets/api/usePostApi';
import useAuthStore from '../../shared/store/useAuthStore';
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox';
import { ImgText } from '../../shared/utils/Heading';
import { OrDivider } from '../../shared/utils/CustomDivider';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { FormAutoComplete } from '../../shared/components/FormFields/FormAutoComplete';
import { useDialog } from '../../shared/hook/useDialog';
import useVisitedPathStore from '../../shared/store/useVisitedPathStore';
import { useToaster } from '../../shared/utils/ToasterProvider';

const EventSubscribeCard = () => {
    const { id, title, apartment } = useParams();
    const { data: eventPriceDetail, isLoading: isEventDetailIsLoading } = usePriceEventDetail({
        apartmentName: apartment,
        title: title
    });
    const { showToaster } = useToaster();

    const user = useAuthStore((state) => state.user);
    const { data: eventDetail, isLoading } = useEventDetail(id);
    const navigate = useNavigate();
   const token = useAuthStore((state) => state.accessToken);
    const location = useLocation();
    const { open: openDialog, handleClickOpen, handleClose } = useDialog();
    const { data: eventApartmentList, isLoading: isLoadingApartmentList } = useEventsApartmentList({ "event_id": id });
    const apartmentOptions = eventApartmentList?.data?.map((apartment, index) => ({
        id: index + 1,
        label: apartment?.apartment_name,
        value: apartment?.apartment_name,
    })) || []
    const createOrderMutation = useMutation({
        mutationFn: (formData) => api.post("collab-event-create-order", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });
    const handlePayment = () => {
        if (!token) {
            useVisitedPathStore.getState().setLastVisitedPath(location.pathname);
            localStorage.setItem("lastVisitedPath", location.pathname);
            navigate("/StudentLogin")
            return
        }
        const obj = {
            "event_id": id,
            "price": eventPriceDetail?.data?.event_fees,
            "quantity": 1,
            "details": {
                "firstname": user?.firstname,
                "lastname": user?.lastname,
                "email": user.email
            }
        }
        createOrderMutation.mutate(obj, {
            onSuccess: (order) => {
                if (!order?.data?.payment_order_id) {
                    showToaster('Warning', 'Failed to get order ID from server', 'warning');
                    return;
                };
                const options = {
                    key: order?.data?.key,
                    amount: order?.data?.amount,
                    currency: "INR",
                    name: "Myskill.club",
                    description: "Payment for event",
                    order_id: order?.data?.payment_order_id,
                    handler: async (response) => {
                        const paymentData = {
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature,
                            event_id: id,
                            price: eventPriceDetail?.data?.event_fees,
                            quantity: 1,
                            apartments_id: eventPriceDetail?.data?.apartments_id,
                            details: {
                                firstname: user?.firstname,
                                lastname: user?.lastname,
                                email: user.email,
                                event_name: title,
                                start_date: eventPriceDetail?.data?.start_date,
                                end_date: eventPriceDetail?.data?.end_date,
                                start_time: eventPriceDetail?.data?.start_time,
                                end_time: eventPriceDetail?.data?.end_time,
                                apartname_name: apartment,
                            }
                        };
                        try {
                            const verifyResponse = await api.post("collab-event-payment-callback", paymentData, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            });
                            if (verifyResponse?.data?.message) {
                                window.location.href = `${Dashboard_URL}student/dashboard`;
                            } else {

                                showToaster('Error', verifyResponse?.data?.message, 'error');
                            }
                        } catch (error) {
                            showToaster('Error', error.response?.data?.message, 'error');
                        }
                    },
                    theme: { color: "#DC143C" }
                };
                const rzp = new window.Razorpay(options);
                rzp.open();
            },
            onError: (error) => {
                showToaster('Error', error.response?.data?.message || "Payment initiation failed", 'error');
            },
        });
    };

    const validationSchema = yup.object().shape({
        apartment: yup.string().required('Apartment is required'),
    });

    const handleSubmit = (values) => {  // ✅ Fix here
        navigate(`/EventDetail/${id}/${values?.apartment}/${eventDetail?.data?.event_name}`)
        handleClose()
    };

    return (

        <>

            <Grid2 container spacing={5}>
                <Grid2 children size={{ xs: 12, lg: 8 }}
                    sx={{
                        maxHeight: { xs: "auto", lg: "80vh" },
                        overflowY: { xs: "auto", lg: "scroll" },
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                    }}
                >

                    {isLoading && <TextSkeleton line={1} width={"100%"} />}
                    {!isLoading && <Typography variant='h1'>
                        {(title && apartment) ? `${title} - ${apartment}` : eventDetail?.data?.event_name}
                    </Typography>}
                    {/* {eventDetail?.data?.event_description && (
                        <Box my={5}>
                            {isLoading && <TextSkeleton line={10} width={"100%"} />}
                            {!isLoading && <BulletList title={"Description"} items={eventDetail?.data?.event_description} />}
                        </Box>
                    )} */}
                </Grid2>

                <Grid2 children size={{ xs: 12, lg: 4 }}>
                    <Card
                        sx={{
                            boxShadow: BOX_SHADOW,
                            border: "1px solid #F0F0F0",
                            p: "32px 22px",
                            borderRadius: "40px"
                        }}>

                        <CardContent>
                            {/* <Box sx={{}}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 1,
                                        alignItems: "center"
                                    }}
                                >
                                    {isLoading && <TextSkeleton width={120} line={1} />}
                                    {!isLoading && <>
                                        {eventDetail?.data?.event_price[0]?.early_bird_discount ? (
                                            <CutCurrency
                                                fontSize={"20px"}
                                                iconSize={"22px"}
                                                value={eventDetail?.data?.event_price[0]?.original_price}
                                            />
                                        ) : null}
                                        <CurrencyRupeeIcon sx={{ color: "red.main", fontSize: "30px" }} />
                                        <Typography variant='h2' fontWeight={500}>{eventDetail?.data?.event_price[0]?.price_with_discount ?? 0}</Typography>
                                    </>
                                    }

                                </Box>
                                {eventDetail?.data?.event_price[0]?.early_bird_discount ? (
                                    <Typography variant='body2'>Discount available till {eventDetail?.data?.event_price[0]?.early_bird_discount_date} {""} {eventDetail?.data?.event_price[0]?.early_bird_discount_time}</Typography>
                                ) : null}



                            </Box>

                            <Box
                                sx={{
                                    border: "0.5px solid #000000",
                                    borderRadius: "40px",
                                    my: 4
                                }}
                            >
                                <Grid2 container>
                                    <Grid2 children size={6} sx={{ borderRight: "0.5px solid #000000", p: 3 }}>
                                        <Typography variant="body2" >Start Date</Typography>
                                        {isLoading && <TextSkeleton width={100} line={1} />}
                                        {!isLoading &&
                                            <Typography variant="body2" fontSize={"12px"}>{eventDetail?.data?.start_date}</Typography>
                                        }

                                    </Grid2>
                                    <Grid2 children size={6} sx={{ p: 3 }}>
                                        <Typography variant="body2">End Date</Typography>

                                        {isLoading && <TextSkeleton width={100} line={1} />}
                                        {!isLoading &&
                                            <Typography variant="body2" fontSize={"12px"}>{eventDetail?.data?.end_date}</Typography>
                                        }
                                    </Grid2>
                                </Grid2>
                                <Box sx={{ p: 3, borderTop: "0.5px solid #000000" }}>
                                    {isLoading && <TextSkeleton width={"100%"} line={3} />}
                                    {!isLoading &&
                                        <> <Typography variant="body2" fontSize={"12px"} my={1}>
                                            Time : {eventDetail?.data?.start_time} - {eventDetail?.data?.end_time}
                                        </Typography>
                                            <Typography variant="body2" fontSize={"12px"} my={1}>
                                                Venue : {eventDetail?.data?.event_venue}
                                            </Typography>
                                            <Typography variant="body2" fontSize={"12px"} my={1}>
                                                Event Type : {eventDetail?.data?.event_type}
                                            </Typography>
                                            <Typography variant="body2" fontSize={"12px"} my={1} color='red.main'>
                                                Available Seat : {eventDetail?.data?.event_available_seats}
                                            </Typography>
                                        </>
                                    }

                                </Box>
                            </Box> */}


                            {(title && apartment) && (
                                <>
                                    <Box sx={{ display: "flex", gap: 2 }}>


                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: 1,
                                                alignItems: "center"
                                            }}
                                        >
                                            <CurrencyRupeeIcon sx={{ color: "red.main", fontSize: "30px" }} />
                                            {isEventDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                            {!isEventDetailIsLoading && <Typography variant='h2' fontWeight={500}>{eventPriceDetail?.data?.event_fees}</Typography>}

                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            border: "0.5px solid #000000",
                                            borderRadius: "40px",
                                            my: 4
                                        }}
                                    >
                                        <Grid2 container>
                                            <Grid2 children size={6} sx={{ borderRight: "0.5px solid #000000", p: 3 }}>

                                                <Typography variant="body2" >Start Date</Typography>
                                                {isEventDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isEventDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{eventPriceDetail?.data?.start_date}</Typography>}

                                                <Typography variant="body2" mt={0.5}>Start Time</Typography>
                                                {isEventDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isEventDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{eventPriceDetail?.data?.start_time}</Typography>}

                                            </Grid2>
                                            <Grid2 children size={6} sx={{ p: 3 }}>
                                                <Typography variant="body2">End Date</Typography>

                                                {isEventDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isEventDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{eventPriceDetail?.data?.end_date}</Typography>}

                                                <Typography variant="body2" mt={0.5}>End Time</Typography>

                                                {isEventDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isEventDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{eventPriceDetail?.data?.end_time}</Typography>}
                                            </Grid2>
                                        </Grid2>

                                    </Box>
                                </>
                            )

                            }

                            {/* <Button variant='contained' fullWidth onClick={handlePayment}> Subscribe</Button> */}
                            <Button variant="contained" fullWidth
                                onClick={(title && apartment) ? handlePayment : handleClickOpen}
                            >
                                {(title && apartment) ? "Purchase Now" : "Enroll Now"}
                            </Button>
                            {
                                !token && <Typography variant='body1' fontSize={"12px"} textAlign={"center"} color='red.main' mt={2}>
                                    Do you have an account ??
                                </Typography>
                            }

                        </CardContent>
                    </Card>
                </Grid2>
            </Grid2 >


            <MainDialogBox open={openDialog} handleClose={handleClose} width={"50%"}>
                <Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center" }}>
                    <ImgText text={"We’d love to know your preference!"} sx={{ fontSize: "30px" }} />
                    <Typography variant='body2' textAlign={"center"} my={1}>Which location would you prefer to attend the Event at? Please select your preferred option below.</Typography>
                    <Box my={4} width={"60%"}>
                        <Formik
                            initialValues={{ apartment: "" }}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}

                        >
                            {() => (
                                <Form>
                                    <Grid2 container spacing={2}>
                                        <Grid2 children size={{ xs: 12, sm: 12 }}>
                                            <Field
                                                name="apartment"
                                                component={FormAutoComplete}
                                                options={apartmentOptions}
                                                label="Apartment"
                                                isRequired={true}
                                                isLoading={isLoadingApartmentList}
                                                nooptionText={"Currently Unavailable"}

                                            />
                                        </Grid2>

                                        <Grid2 children size={{ xs: 12, sm: 12 }}>
                                            <Button variant='contained' fullWidth type="submit">Verify</Button>

                                        </Grid2>
                                    </Grid2>

                                </Form>
                            )}
                        </Formik>
                    </Box>

                    {
                        !token && <>

                            <OrDivider text={"Sign in for a better experience!"} />
                            <Typography variant='h6' fontSize={"12px"} color='grey.100' >Get personalized event updates, faster check-in, and exclusive perks.</Typography>
                        </>
                    }


                </Box>


            </MainDialogBox>

        </>




    )
}

export default EventSubscribeCard